import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const ProjectCard = ({ project }) => {
  return (
    <Link
      to={`/projects/${project._id}`}
      className="group block rounded-xl overflow-hidden bg-white shadow-card hover:shadow-card-hover transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-green-500"
    >
      <article className="flex flex-col md:flex-row">

        {/* Image (NO PADDING) */}
        <div className="relative w-full md:w-2/5 aspect-[16/10] overflow-hidden">
          <img
            src={project.coverImage}
            alt={project.name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />

          {project.starred && (
            <span className="absolute top-3 left-3 z-20 bg-yellow-400 text-white text-xs px-3 py-1 rounded-full shadow-md animate-pulse">
              ★ Featured
            </span>
          )}
        </div>

        {/* Content (WITH PADDING) */}
        <div className="flex flex-col justify-between w-full md:w-3/5 p-5 md:p-7">
          
          <div className="space-y-3">
            {/* Category */}
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
              {project.category}
            </span>

            {/* Title */}
            <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900 leading-snug transition-colors group-hover:text-green-600">
              {project.name}
            </h3>

            {/* Description */}
            <p className="text-gray-500 text-sm md:text-base leading-relaxed line-clamp-3 whitespace-pre-line">
              {project.details}
            </p>

            {/* Thumbnails */}
            {project.images && project.images.length > 0 && (
              <div className="flex gap-2 overflow-x-auto overflow-y-hidden pt-2 hide-scrollbar">
                {project.images.slice(0, 10).map((img, index) => (
                  <img
                    key={img.public_id || index}
                    src={img.url}
                    alt={`thumb-${index}`}
                    className="w-14 h-14 min-w-[56px] object-cover rounded-md border border-gray-200 hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                ))}
              </div>
            )}
          </div>

          {/* CTA */}
          <div className="pt-4">
            <span className="inline-flex items-center text-sm font-medium text-green-600 gap-1 group-hover:gap-2 transition-all">
              Read More
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </span>
          </div>
        </div>

      </article>
    </Link>
  );
};

export default ProjectCard;
